import React, { SetStateAction, useEffect } from 'react';
import { useMemo } from 'react';
import {
  StyledDropDownMenu,
  StyledDropDownMenuItems,
  StyledDropDownMenuItem,
  StyledDropDownMenuItemContainer,
  TitleItem,
  Title,
  SubTitle,
  Item,
} from './Brands.styled';
import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import { reducerTypes } from '../../../store/Product/types';
import { AlumniSansFont } from '../../../styles/fonts';
import LocalizedLink from '../../../components/Link/localized-link';
import slugify from 'slugify';

interface NavLinkDropDownMenuProps {
  brandsNavLinkDropDownVisible: boolean;
  setBrandsNavLinkDropdownVisible: (value: SetStateAction<boolean>) => void;
}

export const BrandsNavLinkDropDownMenu: React.FC<NavLinkDropDownMenuProps> = ({
  brandsNavLinkDropDownVisible,
  setBrandsNavLinkDropdownVisible,
}) => {
  const dispatch = useAppDispatch();
  const locale = useAppSelector((st) => st.locale);

  const messages = useMemo(() => {
    return {
      title: locale['header_all_watches_categories_title'],
      items: [0, 1, 2, 3].map((item, index) => [
        locale[`header_brands_row_${index}_item_0`],
        locale[`header_brands_row_${index}_item_1`],
        locale[`header_brands_row_${index}_item_2`],
        locale[`header_brands_row_${index}_item_3`],
        locale[`header_brands_row_${index}_item_4`],
      ]),
      path: ['/all-watches', '/new-arrivals', '/brands', '', ''],
    };
  }, [locale]);

  if (!brandsNavLinkDropDownVisible) return null;

  return (
    <StyledDropDownMenu>
      <StyledDropDownMenuItems>
        <div>
          <StyledDropDownMenuItemContainer>
            <Title>{locale.brands_a_z_caps}</Title>
            <SubTitle>
              <LocalizedLink href={'/brands'}>
                <span style={{ fontWeight: 400, fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif` }}>
                  {locale.brands_view_all_brands}
                </span>
              </LocalizedLink>
            </SubTitle>
          </StyledDropDownMenuItemContainer>
        </div>

        <StyledDropDownMenuItem>
          <StyledDropDownMenuItemContainer>
            <Title>{locale.brands_feature_brands_title}</Title>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '100px' }}>
              {messages.items.map((item, indexRow) =>
                indexRow === 0 ? (
                  <div key={indexRow} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {item.map((item, index) => (
                      <TitleItem key={index}>
                        <LocalizedLink
                          href={`/all-watches/${slugify(item, { lower: true, trim: true, strict: true })}`}
                          onClick={() => {
                            dispatch({ type: reducerTypes.GET_ALL_PRODUCTS, payload: [] });
                            dispatch({ type: reducerTypes.GET_FILTERS, payload: [] });
                            dispatch({ type: reducerTypes.IS_LOADING, payload: true });
                            window.scrollTo(0, 0);
                            setBrandsNavLinkDropdownVisible(false);
                          }}
                        >
                          {item}
                        </LocalizedLink>
                      </TitleItem>
                    ))}
                  </div>
                ) : (
                  <div key={indexRow} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {item.map((item, index) => (
                      <Item key={index}>
                        <LocalizedLink
                          href={`/all-watches/${slugify(item, { lower: true, trim: true, strict: true })}`}
                          onClick={() => {
                            dispatch({ type: reducerTypes.GET_ALL_PRODUCTS, payload: [] });
                            dispatch({ type: reducerTypes.GET_FILTERS, payload: [] });
                            dispatch({ type: reducerTypes.IS_LOADING, payload: true });
                            window.scrollTo(0, 0);
                            setBrandsNavLinkDropdownVisible(false);
                          }}
                        >
                          {item}
                        </LocalizedLink>
                      </Item>
                    ))}
                  </div>
                )
              )}
            </div>
          </StyledDropDownMenuItemContainer>
        </StyledDropDownMenuItem>
      </StyledDropDownMenuItems>
    </StyledDropDownMenu>
  );
};
